import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { StudentDataResponse } from '@nrdy-marketing-engine/cart/@types/student-data';

const getStudents = (clientUuid: string) =>
  apiFetch<{ data: StudentDataResponse }>(`/vtwa/v5/clients/${clientUuid}/students`).then(
    (res) => res?.data || []
  );

export default getStudents;
